/* eslint-disable @typescript-eslint/no-unused-vars */
import { popChildCount, cellMaxWidth } from './variable';

export const headerStyle = ({ palette = {}, iconFontFamily = 'MsAds MDL2 Assets' }) => ({
  '& .header': {
    backgroundColor: palette.white,

    '& .resizable-column-header': {
      position: 'relative',
      userSelect: 'none',

      '& .dragger': {
        width: 18,
        right: -9,
        zIndex: 2,
        height: 'calc(100% + 2px)',
        cursor: 'col-resize',
        userSelect: 'none',
        position: 'absolute',

        '&:hover': {
          '& .dragger-bar': {
            opacity: 1,
          },
        },

        '& .dragger-bar': {
          opacity: 0,
          width: 2,
          height: '100%',
          background: '#0078d4',
          marginRight: 'auto',
          marginLeft: 'auto',
        },
      },
    },

    '& .flex-row:first-child': {
      '& .flex-cell': {
        fontSize: 14,
        fontWeight: 600,
        borderBottom: '2px solid #81868B',
        borderTop: '2px solid #81868B',
      },
    },

    '& .other-group-container': {
      zIndex: 1,
      backgroundColor: '#fff',
    },

    '& .pop-column-header': {
      '& .iconba-Add, & .iconba-Remove': {
        fontWeight: 'bold',
        transform: 'scale(0.8)',
      },
    },

    '& .nested-column-container > .flex-cell': {
      flexGrow: 1,
      width: '100% !important',
      maxWidth: popChildCount * cellMaxWidth,
      '& .dragger': {
        visibility: 'hidden',
      },
    },

    '& .nested-column-container > .nested-column-placeholder': {
      flexGrow: 1,
    },

    // sort icon
    '& .column-header-sortable': {
      cursor: 'pointer',
      '& .glyphicon': {
        fontFamily: iconFontFamily,
      },
      '& .glyphicon-arrow-up:before': {
        content: '"\\EE68"',
      },
      '& .glyphicon-arrow-down:before': {
        content: '"\\EE69"',
      },
    },
  },
});
